module.exports = __webpack_public_path__ + "img/9788990878939.4eb9abef.jpg";